import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslate } from "@tolgee/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen, faXmark } from '@fortawesome/free-solid-svg-icons';

import type { ISteamServer } from '../../pages/ServersPage/ServersPage';

import './ServerInfoModal.css';

interface IServerInfoModal {
  server: ISteamServer | null;
  show: boolean;
  onHide: () => void;
}

const ServerInfoModal = ({ server, show, onHide }: IServerInfoModal) => {
  const { t } = useTranslate();

  if (!server) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      dialogClassName="server-info-modal"
    >
      <Modal.Header>
        <Modal.Title>
          <FontAwesomeIcon
            icon={server.isPassworded ? faLock : faLockOpen}
            style={{ marginRight: '0.5rem', fontSize: '0.9rem' }}
          />
          {server.name}
        </Modal.Title>
        <button className="server-info-close" onClick={onHide} aria-label="Close">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="server-info-section">
          <h6>{t('common.server')} Details</h6>
          <div className="server-info-row">
            <span className="label">{t('common.map')}</span>
            <span className="value">{server.map}</span>
          </div>
          <div className="server-info-row">
            <span className="label">{t('common.players')}</span>
            <span className="value">{server.players} / {server.max_players}</span>
          </div>
          <div className="server-info-row">
            <span className="label">{t('common.version')}</span>
            <span className="value">{server.version}</span>
          </div>
          <div className="server-info-row">
            <span className="label">Address</span>
            <span className="value">{server.connectAddr}</span>
          </div>
        </div>

        <div className="server-info-section">
          <h6>Player List ({server.playerList?.length ?? 0})</h6>
          {server.playerList && server.playerList.length > 0 ? (
            <table className="player-list-table">
              <thead>
                <tr>
                  <th>Ping</th>
                  <th>Name</th>
                  <th className="score-col">Score</th>
                </tr>
              </thead>
              <tbody>
                {server.playerList.map((player, idx) => (
                  <tr key={idx}>
                    <td>{player.ping}</td>
                    <td>{player.name}</td>
                    <td className="score-col">{player.score}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="player-list-empty">No players connected</div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ServerInfoModal;
